module.exports = __webpack_public_path__ + "img/menu-board-thai-express.1ac6f5d4.webp";